import styled from "styled-components";

const IconWrapper = styled.div`
  display: ${({ inline }) => inline && "inline"};
  vertical-align: sub;
`;

export default IconWrapper;
